module.exports = __webpack_public_path__ + "static/media/failure_illustration.529f47e3.png";